import { tv } from 'tailwind-variants'

export const leftComponentVariants = tv({
  slots: {
    image: 'w-40 ml-deca'
  }
})
